import { EditOutlined } from '@ant-design/icons';
import { MyLogo } from '@components';
import { isGranted, L } from '@lib';
import { CreateOrUpdateUserInput, ProfileLogoInput } from '@services';
import { Button, Col, Row, Typography } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import './AccountDetailsHeader.css';

const { Title, Text } = Typography;

interface IProps {
  user: CreateOrUpdateUserInput;
  handleLogoDelete?: () => Promise<void>;
  handleLogoUpdate?: (profileLogo: ProfileLogoInput) => Promise<any>;
}

export const AccountDetailsHeader: React.FC<IProps> = ({
  user,
  handleLogoUpdate,
  handleLogoDelete,
}) => {
  return (
    <Row justify="space-between" className="accountDetailsHeaderWrapper">
      <Col>
        <Row>
          <Col className="logo-container" style={{ marginRight: '16px' }}>
            <MyLogo
              url={user.logo}
              handleLogoDelete={handleLogoDelete}
              handleLogoUpdate={handleLogoUpdate}
            />
          </Col>
          <Col>
            <Row>
              <Col>
                <Title
                  className="userNameDetails"
                  level={1}
                  style={{ marginTop: 0, marginBottom: 5 }}
                >
                  {user.name} {user.surname}
                </Title>
              </Col>
            </Row>
            <Row>
              <Col>
                <Text className="userRole">{user.roleNames.join(',')}</Text>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      {(isGranted('Pages.MyGarage.Manager') || isGranted('Pages.Tenants')) && (
        <Col>
          <Link to={`/my-account/${user.id}`}>
            <Button type="primary" icon={<EditOutlined />}>
              {L('Edit')}
            </Button>
          </Link>
        </Col>
      )}
    </Row>
  );
};
